const dataCategories = [
    {
        id: 1,
        nameh1: 'SANDALIAS',
        namep: 'POR UN VERANO A PATA PELÁ',
        url: 'https://www.hakahonu.cl/sandalias-verano.html',
        button: 'VER MÁS',
        class: 'c4-1'
    },
    {
        id: 2,
        nameh1: 'JOCKEYS Y CALCETINES',
        namep: 'COMODIDAD Y ESTILO PARA CUALQUIER LADO',
        url: 'https://www.hakahonu.cl/calcetines-y-jockeys.html',
        button: 'VER MÁS',
        class: 'c4-2'
    }
];

export default dataCategories;